import { useRef, useState, useCallback } from 'react'

const useRecaptcha = () => {
  const [recaptchaToken, setRecaptchaToken] = useState(null)
  const recaptchaRef = useRef(null)

  const handleRecaptchaChange = useCallback((token) => {
    setRecaptchaToken(token)
  }, [])

  const getRecaptchaToken = useCallback(async () => {
    // If we already have a token, return it
    if (recaptchaToken) {
      return recaptchaToken
    }

    // If recaptcha is enabled (checked by presence of ref) but no token, try to execute
    if (process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY && recaptchaRef.current) {
      try {
        const token = await recaptchaRef.current.executeAsync()
        setRecaptchaToken(token)
        return token
      } catch (error) {
        console.error('Recaptcha execution failed:', error)
        return null
      }
    }

    return null
  }, [recaptchaToken])

  const resetRecaptcha = useCallback(() => {
    setRecaptchaToken(null)
    if (recaptchaRef.current) {
      recaptchaRef.current.reset()
    }
  }, [])

  return {
    recaptchaRef,
    recaptchaToken,
    handleRecaptchaChange,
    getRecaptchaToken,
    resetRecaptcha
  }
}

export default useRecaptcha
